import top10000 from './top-10000';

const validationFunctions = {
  notEmptyString: {
    check(value) {
      return value.length;
    },
    errorMsg: (field) => validations[field].fieldName + ' is required',
  },
  validEmail: {
    check(value) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return value.length == 0 || re.test(String(value).toLowerCase());
    },
    errorMsg: () => 'Please enter a valid email address',
  },

  businessEmailPreferred: {
    check(value) {
      if (!value) return true;

      const lower = value.toLowerCase();

      const consumerDomains = [
        'gmail.com',
        'hotmail.com',
        'outlook.com',
        'yahoo.com',
        'icloud.com',
        'live.com',
        'msn.com',
      ];

      const domain = lower.split('@')[1] || '';

      return !consumerDomains.includes(domain);
    },
    errorMsg: () =>
      "It looks like you're using a personal email. Please use a business email or fill out the below section.",
  },

  passwordNotCommon: {
    check(value) {
      return top10000.indexOf(value) < 0;
    },
    errorMsg: () => 'This password is known to be vulnerable',
  },
  passwordLongEnough: {
    check(value) {
      return value.length == 0 || value.length >= 10;
    },
    errorMsg: () => 'Passwords should be at least 10 characters long',
  },
  passwordsMatch: {
    check(paswordConf, values) {
      return paswordConf.length == 0 || paswordConf === values.password;
    },
    errorMsg: () => 'Passwords do not match',
  },
  personalEmailExplanationRequired: {
    check(value, values) {
      if (!values.allowPersonalEmail) return true;
      return value && value.trim().length > 10;
    },
    errorMsg: () => 'Please provide a brief description so we can better support your use case.',
  },
};

const validations = {
  email: {
    fieldName: 'Email',
    blur: [
      validationFunctions.validEmail,
      validationFunctions.notEmptyString,
      validationFunctions.businessEmailPreferred,
    ],
    submit: [
      validationFunctions.validEmail,
      validationFunctions.notEmptyString,
      validationFunctions.businessEmailPreferred,
    ],
  },
  password: {
    fieldName: 'Password',
    input: [validationFunctions.passwordNotCommon],
    blur: [validationFunctions.passwordNotCommon, validationFunctions.passwordLongEnough],
    submit: [
      validationFunctions.passwordNotCommon,
      validationFunctions.passwordLongEnough,
      validationFunctions.notEmptyString,
    ],
  },
  passwordConf: {
    fieldName: 'Confirm Password',
    blur: [validationFunctions.passwordsMatch],
    submit: [validationFunctions.passwordsMatch, validationFunctions.notEmptyString],
  },
  personalEmailExplanation: {
    fieldName: 'Intended Use',
    submit: [validationFunctions.personalEmailExplanationRequired],
  },
};

export default class Validator {
  constructor(values) {
    this.values = values;
  }

  validate(field, event) {
    const errorMsgs = [];

    validations[field][event].forEach((check) => {
      if (!check.check(this.values[field], this.values)) {
        errorMsgs.push(check.errorMsg(field));
      }
    });

    return errorMsgs;
  }
}
